import { getHgSuperPayMenu } from "./hgSuperPayNavigation";

// Read only the announcement fields supplied by /user/me/profile.
export const sameProfileId = (a, b) => a != null && b != null && String(a) === String(b);
const validId = id => /^[1-9]\d*$/.test(String(id));

export function announcementRecords(profiles) {
    const records = [];
    (profiles || []).forEach(profile => {
        if (!profile) return;
        records.push(profile);
    });
    return records;
}

export function resolveMvrAnnouncement(store) {
    const active = store.currentProfile;
    if (!active || store.isLoadingProfile) return null;
    const profileId = active.id;
    if (!validId(profileId)) return null;
    return {
        profileId,
        mvrAnnouncementRead: active.mvrAnnouncementRead,
        mvrAnnouncementReadAt: active.mvrAnnouncementReadAt
    };
}

// UI consumers share the sidebar gate; the acknowledgement store still
// resolves the acting profile independently of navigation eligibility.
export function resolveVisibleMvrAnnouncement(store, organisationStore) {
    return getHgSuperPayMenu(store, organisationStore) ? resolveMvrAnnouncement(store) : null;
}
